export const contactPageContent = {
    en: {
        title: "Contact",
        contact: {
            name: "Revimo Team:",
            email: "Email:",
            location: "Location:",
            locationACC: "Maribor, Slovenia",
        },
    },
    sl: {
        title: "Kontakt",
        contact: {
            name: "Revimo ekipa:",
            email: "Email:",
            location: "Lokacija:",
            locationACC: "Maribor, Slovenija",
        },
    },
} as const;
